<template>
    <div>
        <h1>{{ _mft('dashboard:sharing.title') }}</h1>
        <h2>{{ _mft('dashboard:sharing.subtitle') }}</h2>

        <p>{{ _mft('dashboard:sharing.description') }}</p>

        <button-success
            @click="shareSlideout = true"
        >
            {{ _mft('dashboard:sharing.cta') }}
        </button-success>

        <slideout-with-slots
            v-if="shareSlideout"
            @close="shareSlideout = false"
            max-width-class="max-w-[90vw] md:max-w-screen"
        >
            <template #title>
                <h2>
                    {{ _mft('dashboard:sharing.title') }}
                </h2>
            </template>
            <template #body>

                <div class="grid-cols-5 gap-8 md:grid">
                    <div class="col-span-1">
                        </div>
                    <div class="col-span-3">
                        <p>
                            {{ _mft('dashboard:sharing.modalDescription') }}
                        </p>
                        <div>
                            <form @submit.prevent="handleSubmit">
                                <input-text
                                    :label="_mft('dashboard:sharing.form.nameLabel')"
                                    type="text"
                                    maxlength="100"
                                    class="!mb-2"
                                    id="invite-name"
                                    v-model:content="formData.name"
                                    :placeholder="_mft('dashboard:sharing.form.namePlaceholder')"
                                    required
                                ></input-text>
                                <input-text
                                    :label="_mft('dashboard:sharing.form.emailLabel')"
                                    type="email"
                                    maxlength="100"
                                    class=""
                                    id="invite-email"
                                    v-model:content="formData.email"
                                    :placeholder="_mft('dashboard:sharing.form.emailPlaceholder')"
                                    required
                                ></input-text>

                                <div v-if="data.communities != null">
                                    <p class="text-sm">
                                        {{ _mft('dashboard:sharing.form.communityQuestion') }}
                                    </p>

                                    <button-bar
                                        size="sm"
                                        :options="communityInviteOptions"
                                        :selectedOptionName="formData.inviteToCommunity"
                                        @select="formData.inviteToCommunity = $event.name"
                                    />

                                    <div
                                        v-if="formData.inviteToCommunity === 'yes'"
                                    >
                                        <p class="text-sm">
                                            {{ _mft('dashboard:sharing.form.communityHelp') }}
                                        </p>
                                        <input-checkboxes
                                            :options="data.communities.map(c => ({ label: c.name, value: c.id }))"
                                            v-model:content="formData.community"
                                        />
                                    </div>
                                </div>

                                <div class="flex justify-stretch">
                                    <button type="submit" class="block w-full">
                                        <button-success
                                            size="sm"
                                            class="justify-center w-full"
                                        >
                                            {{ _mft('dashboard:sharing.form.submit') }}
                                        </button-success>
                                    </button>
                                </div>

                                <p v-if="responseMessage" class="mt-2" :class="{'text-green-900': response?.data?.success, 'text-red-800': !response?.data?.success}">
                                    {{ _mft(responseMessage) }}
                                    <span v-if="response?.data?.success" class="ml-2">
                                        {{ _mft('dashboard:sharing.form.closingCountdown', { seconds: countdown }) }}
                                    </span>
                                </p>
                            </form>

                        </div>
                    </div>
                </div>

            </template>
        </slideout-with-slots>
    </div>
</template>

<script setup>
    import { ref, onMounted, computed } from 'vue';
    import axios from 'axios';

    const shareSlideout = ref(false);

    const data = ref({
        communities: null,
    });

    const formData = ref({
        name: '',
        email: '',
        inviteToCommunity: 'no',
        community: []
    });

    const responseMessage = ref('');
    const response = ref(null);
    const countdown = ref(10);
    let countdownInterval = null;

    const communityInviteOptions = computed(() => ([
        { label: _mft('dashboard:sharing.form.yes'), name: 'yes' },
        { label: _mft('dashboard:sharing.form.no'), name: 'no' }
    ]));

    const startCountdown = () => {
        countdown.value = 10;
        countdownInterval = setInterval(() => {
            countdown.value--;
            if (countdown.value <= 0) {
                clearInterval(countdownInterval);
                shareSlideout.value = false;
            }
        }, 1000);
    };

    const handleSubmit = async () => {
        try {
            response.value = await axios.post(route('boIndex.dashboardV2SharingInvite'), {
                name: formData.value.name,
                email: formData.value.email,
                inviteToCommunity: formData.value.inviteToCommunity,
                community: formData.value.community
            });

            if (response.value.data.success) {
                formData.value = {
                    name: '',
                    email: '',
                    inviteToCommunity: 'no',
                    community: []
                };
                startCountdown();
            }

            responseMessage.value = response.value.data.message ?? 'dashboard:sharing.errorSendingInvite';
        } catch (error) {
            response.value = error.response;
            responseMessage.value = error.response?.data?.message ?? 'dashboard:sharing.errorSendingInvite';
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(route('boIndex.dashboardV2Sharing'));
            data.value = response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    onMounted(fetchData);
</script>

<style scoped>

</style>
